import { render, staticRenderFns } from "./PayMeBadge.vue?vue&type=template&id=042d8d08&lang=pug&"
import script from "./PayMeBadge.vue?vue&type=script&lang=js&"
export * from "./PayMeBadge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports